import {
    FETCH_GDPR_FEATURE,
    FETCH_GDPR_FEATURE_SUCCESS,
    FETCH_GDPR_FEATURE_FAIL,
    FETCH_GDPR_FEATURE_RESET,
    FETCH_GDPR_FEATURE_STATE_RESET,
    POST_GDPR_FEATURE_OPT_IN,
    POST_GDPR_FEATURE_OPT_OUT
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    features: {},
    gdprGetFeatureSuccess: null
};

const fetchGdprFeatureSuccess = (isSuccess) => (state, action) => {
    let features = { ...state.features };
    features[action.key] = action.feature;
    return {
        isFetching: false,
        features: features,
        gdprGetFeatureSuccess: isSuccess
    };
};

const resetGdprFeatureState = (state, action) => {
    let features = { ...state.features };
    features[action.key] = null;
    return {
        ...state,
        features: features
    };
};

const handlers = {
    [FETCH_GDPR_FEATURE_SUCCESS]: fetchGdprFeatureSuccess(true),
    [FETCH_GDPR_FEATURE_FAIL]: fetchGdprFeatureSuccess(false),
    [FETCH_GDPR_FEATURE_RESET]: resetGdprFeatureState,
    [FETCH_GDPR_FEATURE_STATE_RESET]: fetchGdprFeatureSuccess(null)
};

export default function GdprFeature(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function fetchGdprFeature(key) {
    return {
        type: FETCH_GDPR_FEATURE,
        key: key,
        isFetching: true
    };
}

export function resetGdprFeature(key) {
    return {
        type: FETCH_GDPR_FEATURE_RESET,
        key
    };
}

export const postGdprFeatureOptIn = (key) => {
    return {
        type: POST_GDPR_FEATURE_OPT_IN,
        key: key
    };
};

export const postGdprFeatureOptOut = (key) => {
    return {
        type: POST_GDPR_FEATURE_OPT_OUT,
        key: key
    };
};

export const getGdprFeature = (state, key) => {
    return state.gdprFeature.features[key];
};

export const getGdprFetchState = (state) => {
    return state.gdprFeature.gdprGetFeatureSuccess;
};

export const resetGdprFeatureFetchState = () => {
    return {
        type: FETCH_GDPR_FEATURE_STATE_RESET
    };
};
